export default function RuleStepValidation(step,role){
    var bool_rule = false;
    if(step == 1 && role === "User-tm" || role === "administrateur")
    {
        bool_rule = true;
    }else if(step === 2 && role === "User-asm" || role === "administrateur"){
        bool_rule = true;
    }else if(step == 3 && role === "User-rsm" || role === "administrateur"){
        bool_rule = true;
    }else if(step == 4 && role === "TMC" || role === "administrateur"){
        bool_rule = true;
    }else if(step == 5 && role === "User-tm" || role === "administrateur"){
        bool_rule = true;
    }else if(step == 6 && role === "User-tm" || role === "administrateur"){
        bool_rule = true;
    }else if(step == 7 && role === "TMC" || role === "administrateur"){
        bool_rule = true;
    }else if(step == 8 && role === "commercial" || role === "administrateur"){
        bool_rule = true;
    }else if(step == 9 && role === "TMC" || role === "administrateur"){
        bool_rule = true;
    }
    return bool_rule;
} 